import { ReservationInfo } from './Index';
import { fetchCognitoId } from './ValidationPage';
import { notMatchCustomErrorMessage } from '@/lib/sentryClient';
import * as Sentry from '@sentry/react';
import { executePost } from '@/client/rest';

export type ReviewInfo = {
  evaluation: number;
  q1answer: string[];
  q1other: string;
  q2answer: string[];
  q2other: string;
};

export async function registerEvaluation(reservationInfo: ReservationInfo, reviewInfo: ReviewInfo) {
  try {
    const cognitoId = await fetchCognitoId();
    if (cognitoId === undefined) return;
    await executePost({
      apiName: 'medirecoWebApi',
      path: '/register-evaluation',
      options: {
        body: { cognitoId: cognitoId, ...reservationInfo, ...reviewInfo }
      }
    });
  } catch (e) {
    if (e instanceof Error && notMatchCustomErrorMessage(e.name)) {
      Sentry.captureException(e);
    }

    console.log(e);
  }
}
